<template>
  <aside 
    class="srm-sidebar" 
    :class="{ 
      'is-collapsed': collapsed && !isMobile, 
      'is-mobile': isMobile,
      'is-hidden': collapsed && isMobile 
    }"
  >
    <div class="toggle-bar" @click="handleToggle">
      <span class="toggle-arrow">{{ toggleIcon }}</span>
      <span v-if="showText" class="toggle-text">{{ toggleText }}</span>
    </div>

    <nav class="menu-list">
      <div
        v-for="item in menus"
        :key="item.key"
        class="menu-item"
        :class="{ 'is-active': activeKey === item.key }"
        @click="handleClick(item.key)"
      >
        <span class="item-icon">{{ item.icon }}</span>
        <span v-if="showText" class="item-name">{{ item.name }}</span>
        <span v-if="showText && activeKey === item.key" class="active-indicator"></span>
      </div>
    </nav>

    <div v-if="showText" class="sidebar-footer">
      <div class="footer-line"></div>
      <span class="footer-ver">SRM SYSTEM v2.0</span>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'SrmSidebar',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    activeKey: {
      type: String,
      default: 'SrmDashboard'
    }
  },
  data() {
    return {
      menus: [
        { key: 'SrmDashboard', name: '首页大屏', icon: '◈' },
        { key: 'SrmSupplierAccess', name: '供应商准入', icon: '◉' },
        { key: 'SrmSourcing', name: '采购寻源', icon: '◎' },
        { key: 'SrmContract', name: '合同管理', icon: '▣' },
        { key: 'SrmOrder', name: '订单协同', icon: '▤' },
        { key: 'SrmPerformance', name: '绩效评估', icon: '◆' },
        { key: 'SrmCollaboration', name: '信息协同', icon: '◊' }
      ]
    }
  },
  computed: {
    showText() {
      if (this.isMobile) return !this.collapsed
      return !this.collapsed
    },
    toggleIcon() {
      if (this.isMobile) return this.collapsed ? '☰' : '✕'
      return this.collapsed ? '→' : '←'
    },
    toggleText() {
      if (this.isMobile) return this.collapsed ? '展开菜单' : '收起菜单'
      return this.collapsed ? '展开' : '收起'
    }
  },
  methods: {
    handleToggle() {
      this.$emit('toggle')
    },
    handleClick(key) {
      if (this.activeKey !== key) {
        this.$emit('change', key)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.srm-sidebar {
  width: 220px;
  height: 100%;
  background: #011039;
  border-right: 1px solid rgba(0, 212, 255, 0.15);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.3s ease, transform 0.3s ease;
  position: relative;
  z-index: 999;
  user-select: none;

  &.is-collapsed {
    width: 64px;

    // 折叠时：菜单项变正方形，完全居中
    .menu-item {
      width: 48px;
      height: 48px;
      margin: 6px 8px;  // 左右8px，让48px图标在64px侧边栏中居中
      padding: 0;
      justify-content: center;
      align-items: center;

      .item-icon {
        margin: 0;
        font-size: 18px;
      }
    }

    // 折叠时：隐藏激活指示条（位置不够）
    .active-indicator {
      display: none;
    }

    // 折叠时：切换条也居中
    .toggle-bar {
      justify-content: center;
      padding: 0;

      .toggle-text {
        display: none;
      }
    }
  }

  &.is-mobile {
    position: fixed;
    left: 0;
    top: 72px;
    bottom: 0;
    width: 220px !important;
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.6);

    @media (max-width: 768px) {
      top: 60px;
    }

    &.is-hidden {
      transform: translateX(-100%);
    }
  }
}

/* ==================== 切换条 ==================== */
.toggle-bar {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  color: #8c9bb3;
  transition: all 0.3s;

  &:hover {
    color: #00d4ff;
    background: rgba(0, 212, 255, 0.05);
  }
}

.toggle-arrow {
  font-size: 14px;
  transition: transform 0.3s;
}

.toggle-text {
  font-size: 12px;
  white-space: nowrap;
}

/* ==================== 菜单列表 ==================== */
.menu-list {
  flex: 1;
  padding: 12px 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 212, 255, 0.2);
    border-radius: 2px;
  }
}

.menu-item {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  margin: 4px 12px;
  padding: 0 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #8c9bb3;
  white-space: nowrap;
  overflow: hidden;

  &:hover {
    background: rgba(0, 212, 255, 0.08);
    color: #fff;
  }

  &.is-active {
    background: rgba(0, 212, 255, 0.12);
    color: #00d4ff;
    border: 1px solid rgba(0, 212, 255, 0.3);
    box-shadow: 0 0 15px rgba(0, 212, 255, 0.15), inset 0 0 10px rgba(0, 212, 255, 0.05);
  }
}

.item-icon {
  font-size: 16px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
  display: inline-block;
}

.item-name {
  margin-left: 12px;
  font-size: 14px;
  transition: opacity 0.2s;
}

.active-indicator {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 18px;
  background: #00d4ff;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.8);
  animation: indicatorPulse 2s infinite;
}

@keyframes indicatorPulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 8px rgba(0, 212, 255, 0.8); }
  50% { opacity: 0.6; box-shadow: 0 0 4px rgba(0, 212, 255, 0.4); }
}

/* ==================== 底部 ==================== */
.sidebar-footer {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.footer-line {
  width: 50%;
  height: 1px;
  background: rgba(0, 212, 255, 0.15);
}

.footer-ver {
  font-size: 10px;
  color: rgba(140, 155, 179, 0.4);
  letter-spacing: 1px;
}
</style>